module.exports = __webpack_public_path__ + "img/na-costs-graph-screen.aa39bda7.png";